import { render, staticRenderFns } from "./QueueChatsList.vue?vue&type=template&id=1b473e6e&scoped=true&"
import script from "./QueueChatsList.vue?vue&type=script&lang=js&"
export * from "./QueueChatsList.vue?vue&type=script&lang=js&"
import style0 from "./QueueChatsList.vue?vue&type=style&index=0&id=1b473e6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b473e6e",
  null
  
)

export default component.exports